import styled from '@emotion/styled';
import { Color } from '@diritto/common/style/color';
import { FontWeight } from '@diritto/common/style/typography';
import { hexToRGBA } from '@diritto/common/utils/style';
import { ClockIcon } from 'icons/ClockIcon';

export const HiddenReservationBadge = ({ reservedHideContentsDiffDays }: { reservedHideContentsDiffDays: number }) => (
  <StyledHiddenReserveBadgeWrapper>
    <StyledIcon>
      <ClockIcon />
    </StyledIcon>
    <StyledText>{`D-${reservedHideContentsDiffDays === 0 ? 'day' : reservedHideContentsDiffDays}`}</StyledText>
  </StyledHiddenReserveBadgeWrapper>
);

const StyledHiddenReserveBadgeWrapper = styled.div`
  display: flex;
  height: 16px;
`;

const StyledIcon = styled.div`
  border-radius: 2px 0 0 2px;

  border-top: 0.5px solid ${hexToRGBA(Color.Red400, 0.3)};
  border-left: 0.5px solid ${hexToRGBA(Color.Red400, 0.3)};
  border-bottom: 0.5px solid ${hexToRGBA(Color.Red400, 0.3)};

  padding: 2px;

  display: flex;
  align-items: center;
  justify-content: center;

  background: ${Color.Red400};
`;

const StyledText = styled.div`
  border-radius: 0 2px 2px 0;

  border-top: 0.5px solid ${hexToRGBA(Color.White, 0.3)};
  border-right: 0.5px solid ${hexToRGBA(Color.White, 0.3)};
  border-bottom: 0.5px solid ${hexToRGBA(Color.White, 0.3)};

  padding: 0 5px;
  background-color: ${hexToRGBA(Color.Black, 0.6)};
  height: 100%;

  display: flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;

  color: ${Color.White};

  font-size: 9px;
  line-height: 8px;
  font-weight: ${FontWeight.Medium};
`;
